'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of waiting
 */ const Waiting = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3792_1123)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M69.5 32.0724C69.5 41.8024 63.94 50.0424 56.56 52.6024C63.94 55.2724 69.5 63.5124 69.5 73.1324C70.89 73.1324 72.07 74.3124 72.07 75.7024V77.4124C72.07 78.9124 70.89 79.9824 69.5 79.9824H33.57C32.07 79.9824 31 78.9124 31 77.4124V75.7024C31 74.3124 32.07 73.1324 33.57 73.1324C33.57 63.5024 39.02 55.2724 46.4 52.6024C39.02 50.0424 33.57 41.8124 33.57 32.0724C32.07 32.0724 31 31.0024 31 29.5024V27.7924C31 26.4124 32.07 25.2324 33.57 25.2324H69.51C70.9 25.2324 72.08 26.4124 72.08 27.8024V29.5124C72.08 31.0124 70.9 32.0824 69.51 32.0824L69.5 32.0724Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M38.3936 38.3027C40.5575 44.5709 45.777 48.9898 51.8721 48.9898C57.9672 48.9898 63.1867 44.5709 65.3507 38.3027H38.3936Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M40.6732 62.7559C38.5735 65.7281 37.3105 69.5505 37.3105 73.7207C37.3105 73.8612 37.312 74.0014 37.3148 74.1411H66.3981C66.401 74.0014 66.4024 73.8612 66.4024 73.7207C66.4024 69.5505 65.1395 65.7281 63.0398 62.7559H40.6732Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3792_1123",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "41.07",
                        height: "54.76",
                        fill: "white",
                        transform: "translate(31 25.2324)"
                    })
                })
            })
        ]
    });
};

exports.Waiting = Waiting;
//# sourceMappingURL=Waiting.cjs.map
